import React from 'react';
import { useSelector } from 'react-redux';
import { selectPrerenderStateFromBootstrap } from 'store/slice/bootstrap';

export const useIsPrerender = () => useSelector(selectPrerenderStateFromBootstrap);

const PrerenderShow = (props: { children: React.ReactNode }) => {
    if (useIsPrerender()) {
        return <>{props.children}</>;
    }
    return null;
};
PrerenderShow.displayName = 'Prerender.Show';

const PrerenderHide = (props: { children: React.ReactNode }) => {
    if (useIsPrerender()) {
        return null;
    }
    return <>{props.children}</>;
};
PrerenderHide.displayName = 'Prerender.Hide';

export default {
    Show: PrerenderShow,
    Hide: PrerenderHide,
};
